import { render } from "./Story.vue?vue&type=template&id=470c3a70"
import script from "./Story.vue?vue&type=script&lang=js"
export * from "./Story.vue?vue&type=script&lang=js"

import "./Story.vue?vue&type=style&index=0&id=470c3a70&lang=scss"
script.render = render

export default script